export const getLocationList = () => {
	return {
		method: "GET",
		url: `${process.env.REACT_APP_ORIGIN}/locations/location`,
	}
}
